module.exports = __webpack_public_path__ + "img/kisuke.33e211d4.svg";